/**
 * Initialize the event handlers.
 *
 * @param {*} callback
 */
export default (callback) => {
	// Event handlers for removing filter options
	document.addEventListener('click', async function (e) {
		if (e.target.matches('.js-gsfc-filter-draw-tax')) {
			e.preventDefault();
			await removeTax(e.target);
			callback();
		} else if (e.target.matches('.js-gsfc-filter-draw-date')) {
			e.preventDefault();
			await removeDate();
			callback();
		} else if (e.target.matches('.js-gsfc-filter-draw-order')) {
			e.preventDefault();
			await removeOrder();
			callback();
		} else if (e.target.matches('.js-gsfc-filter-draw-post-type')) {
			e.preventDefault();
			await removePostType(e.target);
			callback();
		} else if (e.target.matches('.js-gsfc-filter-draw-clear')) {
			e.preventDefault();
			const elements = e.target
				.closest('div')
				.querySelectorAll('button:not(.js-gsfc-filter-draw-clear)');
			elements.forEach(async function (elem) {
				if (elem.classList.contains('js-gsfc-filter-draw-tax')) {
					await removeTax(elem);
					callback();
				} else if (
					elem.classList.contains('js-gsfc-filter-draw-date')
				) {
					await removeDate();
					callback();
				} else if (
					elem.classList.contains('js-gsfc-filter-draw-order')
				) {
					await removeOrder();
					callback();
				} else if (
					elem.classList.contains('js-gsfc-filter-draw-post-type')
				) {
					await removePostType(elem);
					callback();
				}
			});
		}
	});
};

/**
 * Remove taxonomy filter.
 *
 * @param {HTMLElement} elem The clicked element.
 * @return {Promise} A Promise that resolves when the taxonomy filter is removed.
 */
const removeTax = (elem) => {
	return new Promise((resolve) => {
		const tax = elem.getAttribute('data-tax');
		const value = elem.getAttribute('data-value');
		const index = global.filters.taxonomies[tax].terms.findIndex(
			(item) => item[0] === value
		);
		if (index > -1) {
			global.filters.taxonomies[tax].terms.splice(index, 1);
		}
		resolve();
	});
};

/**
 * Remove date filter.
 *
 * @return {Promise} A Promise that resolves when the date filter is removed.
 */
const removeDate = () => {
	return new Promise((resolve) => {
		global.filters.date_range_from = '';
		global.filters.date_range_to = '';
		resolve();
	});
};

/**
 * Remove order filter.
 *
 * @return {Promise} A Promise that resolves when the order filter is removed.
 */
const removeOrder = () => {
	return new Promise((resolve) => {
		global.filters.order = 'Date';
		resolve();
	});
};

/**
 * Remove post type filter.
 *
 * @param {HTMLElement} elem The clicked element.
 * @return {Promise} A Promise that resolves when the post type filter is removed.
 */
const removePostType = (elem) => {
	return new Promise((resolve) => {
		const postType = elem.getAttribute('data-post-type');
		const index = global.filters.post_types.findIndex(
			(item) => item === postType
		);
		if (index > -1) {
			global.filters.post_types.splice(index, 1);
		}
		resolve();
	});
};
